define(()=> {
    //Depends on ./StackedMap.js, but that one should defined as angular module
    return ['$document', '$compile', '$rootScope', '$$stackedMap',
        function ($document, $compile, $rootScope, $$stackedMap) {
            const OPENED_MODAL_CLASS = 'gw-modal-open';

            let backdropjqLiteEl;
            let backdropDomEl;
            const backdropScope = $rootScope.$new(true);
            const openedWindows = $$stackedMap.createNew();
            const $modalStack = {};

            function backdropIndex() {
                let topBackdropIndex = -1;
                const opened = openedWindows.keys();
                for (let i = 0; i < opened.length; i++) {
                    if (openedWindows.get(opened[i]).value.backdrop) {
                        topBackdropIndex = i;
                    }
                }
                return topBackdropIndex;
            }

            $rootScope.$watch(backdropIndex, (newBackdropIndex)=> {
                backdropScope.index = newBackdropIndex;
            });

            function removeModalWindow(modalInstance) {
                const body = $document.find('body').eq(0);
                const modalWindow = openedWindows.get(modalInstance).value;

                //clean up the stack
                openedWindows.remove(modalInstance);

                //remove window DOM element
                modalWindow.modalDomEl.remove();
                body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);

                //remove backdrop if no longer needed
                if (backdropDomEl && backdropIndex() === -1) {
                    backdropDomEl.remove();
                    backdropDomEl = undefined;
                }

                //destroy scope
                modalWindow.modalScope.$destroy();
            }

            $document.bind('keydown', (evt)=> {
                let modal;

                if (evt.which === 27) {
                    modal = openedWindows.top();
                    if (modal && modal.value.keyboard) {
                        $rootScope.$apply(()=> {
                            $modalStack.dismiss(modal.key);
                        });
                    }
                }
            });

            $modalStack.open = function (modalInstance, modal) {
                openedWindows.add(modalInstance, {
                    deferred: modal.deferred,
                    modalScope: modal.scope,
                    backdrop: modal.backdrop,
                    keyboard: modal.keyboard
                });

                const body = $document.find('body').eq(0);

                if (backdropIndex() >= 0 && !backdropDomEl) {
                    backdropjqLiteEl = angular.element('<div modal-backdrop></div>');
                    backdropDomEl = $compile(backdropjqLiteEl)(backdropScope);
                    body.append(backdropDomEl);
                }

                const angularDomEl = angular.element('<div modal-window></div>');
                angularDomEl.attr('window-class', modal.windowClass);
                angularDomEl.attr('index', openedWindows.length() - 1);
                angularDomEl.html(modal.content);

                const modalDomEl = $compile(angularDomEl)(modal.scope);
                openedWindows.top().value.modalDomEl = modalDomEl;
                body.append(modalDomEl);
                body.addClass(OPENED_MODAL_CLASS);
            };

            $modalStack.close = function (modalInstance, result) {
                const modal = openedWindows.get(modalInstance);
                if (modal) {
                    modal.value.deferred.resolve(result);
                    removeModalWindow(modalInstance);
                }
            };

            $modalStack.dismiss = function (modalInstance, reason) {
                const modalWindow = openedWindows.get(modalInstance).value;
                if (modalWindow) {
                    modalWindow.deferred.reject(reason);
                    removeModalWindow(modalInstance);
                }
            };

            $modalStack.getTop = function () {
                return openedWindows.top();
            };

            return $modalStack;
        }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/modal/dataStructures/ModalStack.js
 **/